import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment'; 

@Pipe({
  name: 'qdate'
})
export class QdatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    var formate = "DD-MM-YYYY";
    if(args){
      formate = args[0];
    }
    if(!value){
      return "";
    }
    return moment(value).format(formate);
  }

}
